import { get } from 'lodash-es'
export default {
  methods: {
    // 登录弹窗
    showLoginDialog (initFn) {
      return this.$createDialog({
        type: 'confirm',
        icon: 'richic-important',
        title: this.gettext('请登录'),
        // content: this.gettext('请登录'),
        confirmBtn: {
          text: this.gettext('登录'),
          active: true,
          disabled: false,
          href: 'javascript:;'
        },
        cancelBtn: {
          text: this.gettext('取消'),
          active: false,
          disabled: false,
          href: 'javascript:;'
        },
        onConfirm: () => {
          this.requestLogin(initFn)
          setTimeout(() => {
            this.showLoginDialog(initFn).show()
          }, 500)
        },
        onCancel: () => {
          this.SodaBridge('closePage')
        }
      })
    },
    // 去登录
    requestLogin (initFn) {
      this.SodaBridge('requestLogin').then((response) => {
        // 登录后回调
        if (response && get(response, 'data.token', '')) {
          this.showLoginDialog().hide()
          // init页面
          initFn()
        } else {
          this.SodaBridge('closePage')
        }
      })
    },
    // fn为初始化方法
    getTokenToLogin (initFn) {
      Soda.getUserInfo({}, data => {
        // 判断是否有用户token
        if (data && get(data, 'data.token', '')) {
          initFn()
        } else {
          setTimeout(() => {
            this.showLoginDialog(initFn).show()
          }, 500)
          this.requestLogin(initFn)
        }
      })
    }
  }
}
